import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

import LoadingBackdrop from "../LoadingBackdrop";

interface APFormProps {
  children: ReactNode;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  submitText: string;
  submitIcon?: ReactNode;
  leftButton?: ReactNode;
  additionalButton?: ReactNode;
  disableSubmit?: boolean;
  isLoading: boolean;
  isError?: boolean;
  minSpacing?: boolean;
  submitButtonColor?: "primary" | "secondary";
  mobileButtonPosition?: "left" | "right";
  hideSubmitButton?: boolean;
}

const APForm = ({
  children,
  onSubmit,
  submitText,
  submitIcon,
  leftButton,
  additionalButton,
  disableSubmit,
  isLoading,
  isError,
  minSpacing,
  submitButtonColor,
  mobileButtonPosition = "right",
  hideSubmitButton = false,
}: APFormProps) => {
  return (
    <Box sx={{ py: 2 }}>
      {isLoading && <LoadingBackdrop />}
      <Stack
        component="form"
        spacing={minSpacing ? 2 : 4}
        onSubmit={onSubmit}
        noValidate
        sx={{
          "& .MuiFormControl-root, & .MuiTextField-root, & .MuiAutocomplete-root":
            {
              scrollMarginTop: "160px",
              scrollMarginBottom: "80px",
            },
        }}
      >
        {children}
        <Box>
          {isError && (
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Typography variant="labelMedium" color="error.main">
                There are errors in your submission
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              pt: minSpacing ? 1 : 2,
              display: "flex",
              justifyContent: "space-between",
              flexDirection: {
                xs: mobileButtonPosition === "left" ? "column-reverse" : "row",
                sm: "row",
              },
              rowGap: 2,
              columnGap: 2,
            }}
          >
            <Box>{leftButton}</Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
              }}
            >
              {additionalButton && <Box sx={{ mr: 2 }}>{additionalButton}</Box>}
              {!hideSubmitButton && (
                <Button
                  size="large"
                  color={submitButtonColor ?? "secondary"}
                  variant="contained"
                  type="submit"
                  disableElevation={true}
                  startIcon={submitIcon || null}
                  disabled={disableSubmit}
                >
                  {submitText}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default APForm;
